import { RLBaseService } from "./rl-base-service";
import { PromiseCache } from "./promise-cache";

import * as Models from "../ts/rlAdmin.models";

export class AuditHistoryService extends RLBaseService {
    static $inject = ["$resource", "promiseCache"];

    constructor(private $resource: ng.resource.IResourceService, private promiseCache: PromiseCache) {
        super($resource);
    }

    getEntityAuditHistory(entityID: string, filter: Models.IAuditHistoryFilter) {
        var data = {
            entityID: entityID,
            charTypes: filter.charTypes,
            startDate: filter.startDate,
            endDate: filter.endDate,
            emails: filter.emails,
            page: filter.page,
            rows: filter.rows, 
            inUTC: filter.inUTC,
            lastAmendment: filter.lastAmendment
        }
        return this.toRLService<Models.IDataResponse<Models.IAuditHistory[]>>("/api/entity/getentityaudithistory").post(data).$promise;
    }

    getEntityAuditHistoryDetail(charTypes: Models.IAuditHistoryCharType[], isHeader: number, logIndicator: string, sequenceValue: string, operationID: number, templateID: number) {
        var data = {
            charTypes: charTypes,
            isHeader: isHeader,
            logIndicator: logIndicator,
            sequenceValue: sequenceValue,
            operationID: operationID,
            templateID: templateID
        }
        return this.toRLService<Models.IDataResponse<Models.IAuditHistoryDetail[]>>("/api/entity/getentityaudithistorydetail").post(data).$promise;
    }

    getAllowedCharTypes(entityID: string, templateID: number) {
        var data = {
            entityID: entityID,
            templateID: templateID
        }
        return this.toRLService<Models.IDataResponse<Models.IAuditHistoryCharType[]>>("/api/entity/getallowedchartypes").post(data).$promise;
    }

    getEntityAmendments(entityID: string) {
        return this.toRLService<Models.IDataResponse<{ item1: number, item2: Date }[]>>("/api/entity/getentityamendments").get({ entityID: entityID }).$promise;
    }
}